module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-bdc8e1767cc4a1f73a6725a4bfd9f065.webp";